import { Module } from 'vuex'

import { RootState } from '../types'
import getters from './getters'
import actions from './actions'
import mutations from './mutations'
import { UserState } from './types'

export const user: Module<UserState, RootState> = {
  namespaced: true,
  state: {
    data: { user: undefined, loading: false }
  },
  getters,
  actions,
  mutations
}
